import {
    Typography,
    FormControlLabel,
    Switch,
    Grid,
} from '@mui/material';
import { FormikProps } from 'formik';
import { CustomerTypes } from '../../../../../types';
import { SettingsFieldCard } from './settings-field-card';

interface Props {
    formik: FormikProps<CustomerTypes.OnboardingForm>;
    disabled?: boolean;
}

export const MobileAppSettingsTab: React.FC<Props> = ({ formik, disabled = true }) => {
    const { values } = formik;

    const handleFieldChange = (field: string, value: any) => {
        formik.setFieldValue(field, value);
    };

    return (
        <>
            <Typography fontWeight={500} fontSize={18} mt={2}>
                Mobile App Settings
            </Typography>
            <Typography fontSize={14} mb={1} color="text.secondary">
                Control visibility of features in the mobile app for this organization.
            </Typography>

            <SettingsFieldCard>
                <FormControlLabel
                    control={
                        <Switch
                            checked={values?.showAppMessageTab ?? false}
                            onChange={(e) => handleFieldChange('showAppMessageTab', e.target.checked)}
                            disabled={disabled}
                        />
                    }
                    label=""
                    sx={{ my: "auto" }}
                />
                <Grid maxWidth="sm" sx={{ width: 1 }}>
                    <Typography fontWeight="600" fontSize={16}>Messages Tab</Typography>
                    <Typography color="textSecondary" variant="body2">
                        Show or hide the Messages/Notifications tab in the mobile app bottom navigation bar.
                    </Typography>
                </Grid>
            </SettingsFieldCard>

            <SettingsFieldCard>
                <FormControlLabel
                    control={
                        <Switch
                            checked={values?.pushNotificationPromptEnabled ?? true}
                            onChange={(e) => handleFieldChange('pushNotificationPromptEnabled', e.target.checked)}
                            disabled={disabled}
                        />
                    }
                    label=""
                    sx={{ my: "auto" }}
                />
                <Grid maxWidth="sm" sx={{ width: 1 }}>
                    <Typography fontWeight="600" fontSize={16}>Push Notification Prompt</Typography>
                    <Typography color="textSecondary" variant="body2">
                        Allow the mobile app to prompt users to enable push notifications.
                    </Typography>
                </Grid>
            </SettingsFieldCard>

            <SettingsFieldCard>
                <FormControlLabel
                    control={
                        <Switch
                            checked={values?.appUpdatePromptEnabled ?? true}
                            onChange={(e) => handleFieldChange('appUpdatePromptEnabled', e.target.checked)}
                            disabled={disabled}
                        />
                    }
                    label=""
                    sx={{ my: "auto" }}
                />
                <Grid maxWidth="sm" sx={{ width: 1 }}>
                    <Typography fontWeight="600" fontSize={16}>App Update Prompt</Typography>
                    <Typography color="textSecondary" variant="body2">
                        Allow the mobile app to prompt users when an app update is available.
                    </Typography>
                </Grid>
            </SettingsFieldCard>
        </>
    );
};
